import React from 'react';
import { Icon } from '@iconify/react';
import { AppBadge } from '../ui';
import cx from '../ui/cx';
import { AVAILABLE_USER_ROLES, getRoleBadgeVariant, getRoleLabel } from '../../config/userRoles';
import '../../styles/users-admin.scss';

export const UserRoleBadge = ({ role, className = '' }) => (
  <AppBadge variant={getRoleBadgeVariant(role)} pill className={className}>
    {getRoleLabel(role)}
  </AppBadge>
);

const UserRolesPicker = ({
  roles = AVAILABLE_USER_ROLES,
  selected = [],
  onToggle,
  disabled = false,
  onCreate,
}) => (
  <div className="user-tag-picker" role="group" aria-label="Rôles">
    {roles.map((role) => {
      const isSelected = selected.includes(role.value);
      return (
        <AppBadge
          key={role.value}
          as="button"
          type="button"
          pill
          variant={isSelected ? getRoleBadgeVariant(role.value) : 'neutral'}
          className={cx(
            'user-tag',
            isSelected && 'user-tag--selected',
          )}
          aria-pressed={isSelected}
          disabled={disabled}
          onClick={() => onToggle(role.value)}
        >
          {isSelected ? <Icon icon="mdi:check" width={14} aria-hidden /> : null}
          {role.label}
        </AppBadge>
      );
    })}
    {onCreate ? (
      <AppBadge
        as="button"
        type="button"
        pill
        variant="neutral"
        className="user-tag"
        disabled={disabled}
        onClick={onCreate}
      >
        <Icon icon="mdi:plus" width={14} aria-hidden />
        Nouveau rôle
      </AppBadge>
    ) : null}
  </div>
);

export default UserRolesPicker;
